module.exports = __webpack_public_path__ + "static/media/17.10d52690.png";